export default __webpack_public_path__ + "static/media/logo-ies@3x.dfa8ef6c.png";